import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';

import { styled } from '@mui/system';
import { fetchDynamicLinkForFlight, genDeepLinkQueryObject } from '@/utils/hooks/use-fetch-dynamic-link';
import { isAsyncThunkAction } from '@reduxjs/toolkit';
import { add } from 'date-fns';
import { SEO_PAGE_TYPE } from '@/utils/constants';
import { getMultipleFlightTrainConfig } from '@/utils/getMultipleFlightTrainConfig';

const iconBanner = 'https://storage.googleapis.com/fe-production/banner/icon-logo.svg';
const iconClose = 'https://storage.googleapis.com/fe-production/banner/icon-close.svg';

const Container = styled('div')`
  background: white;
  height: '72px' ;
  border-bottom: ${(props: any) => (props.isOpen ? '1px solid #C0C0C0' : 'none')};
  z-index: 3;
  overflow: hidden;
`;

const BodyContent = styled('div')`
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const TextContent = styled('div')`
  height: 48px;
  width: 45%;
`;

const Title = styled('div')`
  font-size: 14px;
  font-weight: bold;
  color: #484848;
`;
const Content = styled('div')`
  font-size: 12px;
  color: #707070;
  line-height: 14px;
`;
const ImgLogo = styled('img')`
  height: 48px;
  width: 48px;
`;

const ImgClose = styled('img')`
  height: 12px;
  width: 12px;
`;

const bannerText: any = {
  vi: {
    title: 'Tải app Vexere',
    content: '-20K/ghế khi đặt vé máy bay qua app',
    button: 'Mở app',
  },
  en: {
    title: 'Get the FREE app',
    content: '-20K/seat flight booking only on Vexere app',
    button: 'Open',
  },
};

const ObjUtmCampain = {
  [SEO_PAGE_TYPE.FROM_TO_PAGE]: 'seo_flight_citytocity',
  [SEO_PAGE_TYPE.AIRLINE_PAGE]: 'seo_flight_company',
  [SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE]: 'seo_flight_companycitytocity',
  [SEO_PAGE_TYPE.AIRLINE_TO_PAGE]: 'seo_flight_companytocity',
  [SEO_PAGE_TYPE.TO_PAGE]: 'seo_flight_tocity',
  [SEO_PAGE_TYPE.AIRPORT_PAGE]: 'seo_flight_airport',
};

const VexDownloadBanner = ({
  lang = 'vi', fromId, toId, airline, pageType,
}: any) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<any>({});

  const fetchConfig = async () => {
    try {
      const configData = await getMultipleFlightTrainConfig();
      setConfig(configData);
    } catch (error) {
      console.log('Error fetching config:', error);
    }
  };

  const closeBanner = () => {
    setOpen(false);
  };
  const openLink = async () => {
    const payload: any = {
      fromId,
      toId,
      date: add(new Date(), { days: 1 }),
      returnDate: null,
      passenger: {
        adt: 1,
        chd: 0,
        inf: 0,
      },
      seatClass: 'PT',
      isRoundTrip: false,
      lang: lang === 'vi' ? 'vi-VN' : 'en-US',
    };

    if (airline) {
      payload.airline = airline;
    }

    try {
      const queryObj = genDeepLinkQueryObject(
        payload,
      );

      const result: any = await fetchDynamicLinkForFlight({
        query: queryObj,
        utm_campaign: (ObjUtmCampain as any)[pageType],
      });
      const shortLink = result?.data?.shortLink;
      window.location.href = shortLink;
    } catch (e) {
      console.error(e, 'e');
    }
    // window.location.href = 'https://vexere.page.link/mobile';
  };
  useEffect(() => {
    fetchConfig();
    setTimeout(() => {
      setOpen(true);
    }, 7000);
  }, []);

  // Get content from config or fallback to default
  const getBannerContent = () => {
    const configLabel = config?.labelFlightTrainHomePage?.smartAppBanner?.label;

    if (configLabel) {
      return {
        title: bannerText[lang].title,
        content: configLabel[lang],
        button: bannerText[lang].button,
      };
    }

    return bannerText[lang];
  };

  const bannerContent = getBannerContent();

  if (!open) return null;
  return (
    <Container
      className="wrapper-banner-down-app"
    >
      <BodyContent>
        <ImgClose
          src={iconClose}
          alt="icon-close"
          onClick={closeBanner}
        />
        <ImgLogo
          src={iconBanner}
          alt="banner-tai-app"
        />
        <TextContent>
          <Title>{bannerContent.title}</Title>
          <Content>{bannerContent.content}</Content>
        </TextContent>
        <Button
          style={{
            margin: 0,
            color: '#48a7ff',
            backgroundColor: 'white',
            borderColor: '#48a7ff',
          }}
          variant="outlined"
          onClick={openLink}
        >
          {bannerContent.button}
        </Button>
      </BodyContent>
    </Container>
  );
};

export default VexDownloadBanner;
